      <div class="grid" *ngIf="carInformacionInicial">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>

      <div *ngIf="!carInformacionInicial">
        <div class="grid">
          <div class="col-12 md:col-10 md:col-offset-1">
            <p-panel header="{{ 'ZONES.LBL_ZONAS' | translate}}" *ngIf="zone">
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ZONES.LBL_CODIGO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8 "><strong>{{zone.codigo}}</strong></label>
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ZONES.LBL_ZONA' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8"><strong>{{zone.nombre}}</strong></label>
              </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ZONES.LBL_DESCRIPCION' | translate }}:</label>
                <label class="lg:col-9 col-6 md:col-8"><strong>{{zone.descripcion}}</strong></label>
              </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ZONES.LBL_CLASIFICACION' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8 "><strong>{{zone.clasificacionZona}}</strong></label>
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8"><strong>{{zone.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
                  translate)}}</strong></label>
              </div>
              <div class="grid" *ngIf="!cargando">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ZONES.LBL_BARRIOSZONE' | translate }}:</label>
                <label class="lg:col-9 col-6 md:col-8"><strong *ngFor="let z of zonesBarrios">{{z.camino}}<br></strong></label>
              </div>
              <div class="grid" *ngIf="cargando">
                <div class="lg:col-12 col-12 md:col-12 text-center"><i class="fa fa-spinner fa-pulse fa-fw"></i> {{ 'LBL_CARGANDO'| translate}}</div>
              </div>
            </p-panel>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                    pButton (click)="goBack()"></button>
          </div>
        </div>
      </div>
